
import fetchAvailableWidgets from './fetchAvailableWidgets';
import fetchUserWidgets from './fetchUserWidgets';
import updateUserWidgets from './updateUserWidgets';
import fetchBestClientsWidgets from './fetchBestClientsWidgets';
import fetchWaitingProcessedWidgets from './fetchWaitingProcessedWidgets';
import fetchWaitingDeliveredWidgets from './fetchWaitingDeliveredWidgets';
import fetchOrderReceivedWidgets from './fetchOrderReceivedWidgets';
import fetchRevenueWidgets from './fetchRevenueWidgets';
import fetchPopularProductsWidgets from './fetchPopularProductsWidgets';
import fetchSoldProductsWidgets from './fetchSoldProductsWidgets';

export default {
  fetchAvailableWidgets,
  fetchUserWidgets,
  updateUserWidgets,
  fetchBestClientsWidgets,
  fetchWaitingProcessedWidgets,
  fetchWaitingDeliveredWidgets,
  fetchOrderReceivedWidgets,
  fetchRevenueWidgets,
  fetchPopularProductsWidgets,
  fetchSoldProductsWidgets,
};



// WEBPACK FOOTER //
// ./src/app/services/widgets/index.js